import { MasterCategoryConst, type MasterCategoryType } from '../types/masterSearchTypes';

// テーブルの列定義
export type ColumnDef = {
  header: string;
  accessor: string;
  width?: string;
  type?: 'text' | 'checkbox' | 'date';
};

// マスタ確認用の設定型定義
export type MasterReferenceConfigType = {
  label: string;
  sourceKey: 'sellers' | 'buyers' | 'farmers'| 'varieties' | 'teaSeasons'| 'teaTypes' | 'gaps'| 'notes' | 'blocks'| 'jas' | 'areas';
  codeCategory?: string;
  columns: ColumnDef[];
};

// マスタ確認画面用の設定
export const MASTER_REFERENCE_CONFIG: Record<MasterCategoryType, MasterReferenceConfigType> = {
  [MasterCategoryConst.SELLER]: {
    label: '売手マスタ',
    sourceKey: 'sellers',
    columns: [
      { header: '売手コード', accessor: 'sellerCode', width: 'w-32' },
      { header: '売手名', accessor: 'sellerName' },
      { header: '更新日時', accessor: 'updatedAt', type: 'date' },
      { header: '削除済', accessor: 'isDeleted', type: 'checkbox' },
    ],
  },
  [MasterCategoryConst.BUYER]: {
    label: '買手マスタ',
    sourceKey: 'buyers',
    codeCategory: 'Buyer', 
    columns: [
      { header: '買手コード', accessor: 'buyerCode', width: 'w-32' },
      { header: '買手名', accessor: 'buyerName' },
      { header: '更新日時', accessor: 'updatedAt', type: 'date' },
      { header: '削除済', accessor: 'isDeleted', type: 'checkbox' },
    ],
  },
  [MasterCategoryConst.FARMER]: {
    label: '生産者マスタ',
    sourceKey: 'farmers',
    columns: [
      { header: '売手コード', accessor: 'sellerCode', width: 'w-32' },
      { header: '生産者コード', accessor: 'farmerCode', width: 'w-32' },
      { header: '生産者名', accessor: 'farmerName' },
      { header: '更新日時', accessor: 'updatedAt', type: 'date' },
      { header: '削除済', accessor: 'isDeleted', type: 'checkbox' },
    ],
  },
  [MasterCategoryConst.VARIETY]: {
    label: '品種マスタ',
    sourceKey: 'varieties',
    codeCategory: 'Variety', 
    columns: [
      { header: '品種コード', accessor: 'varietyCode', width: 'w-32' },
      { header: '品種名', accessor: 'varietyName' },
      { header: '更新日時', accessor: 'updatedAt', type: 'date' },
      { header: '削除済', accessor: 'isDeleted', type: 'checkbox' },
    ],
  },
  [MasterCategoryConst.TEA_SEASON]: {
    label: '茶期マスタ',
    sourceKey: 'teaSeasons',
    codeCategory: 'TeaSeason',
    columns: [
      { header: '茶期コード', accessor: 'teaSeasonCode', width: 'w-32' },
      { header: '茶期名', accessor: 'teaSeasonName' },
      { header: '更新日時', accessor: 'updatedAt', type: 'date' },
      { header: '削除済', accessor: 'isDeleted', type: 'checkbox' },
    ],
  },
  [MasterCategoryConst.TEA_TYPE]: {
    label: '茶種マスタ',
    sourceKey: 'teaTypes',
    codeCategory: 'TeaType',
    columns: [
      { header: '茶種コード', accessor: 'teaTypeCode', width: 'w-32' },
      { header: '茶種名', accessor: 'teaTypeName' },
      { header: '更新日時', accessor: 'updatedAt', type: 'date' },
      { header: '削除済', accessor: 'isDeleted', type: 'checkbox' },
    ],
  },
  [MasterCategoryConst.GAP]: {
    label: 'GAPマスタ',
    sourceKey: 'gaps',
    codeCategory: 'Gap',
    columns: [
      { header: 'GAPコード', accessor: 'gapCode', width: 'w-32' },
      { header: 'GAP名', accessor: 'gapName' },
      { header: '更新日時', accessor: 'updatedAt', type: 'date' },
      { header: '削除済', accessor: 'isDeleted', type: 'checkbox' },
    ],
  },
  [MasterCategoryConst.NOTE]: {
    label: '備考マスタ',
    sourceKey: 'notes',
    codeCategory: 'Note',
    columns: [
      { header: '備考コード', accessor: 'noteCode', width: 'w-32' },
      { header: '備考名', accessor: 'noteName' },
      { header: '更新日時', accessor: 'updatedAt', type: 'date' },
      { header: '削除済', accessor: 'isDeleted', type: 'checkbox' },
    ],
  },
  [MasterCategoryConst.BLOCK]: {
    label: '管内マスタ',
    sourceKey: 'blocks',
    codeCategory: 'Block',
    columns: [
      { header: '管内コード', accessor: 'blockCode', width: 'w-32' },
      { header: '管内名', accessor: 'blockName' },
      { header: '更新日時', accessor: 'updatedAt', type: 'date' },
      { header: '削除済', accessor: 'isDeleted', type: 'checkbox' },
    ],
  },
  [MasterCategoryConst.JA]: {
    label: '農協マスタ',
    sourceKey: 'jas',
    codeCategory: 'JA',
    columns: [
      { header: '農協コード', accessor: 'jaCode', width: 'w-32' },
      { header: '農協名', accessor: 'jaName' },
      { header: '更新日時', accessor: 'updatedAt', type: 'date' },
      { header: '削除済', accessor: 'isDeleted', type: 'checkbox' },
    ],
  },
  [MasterCategoryConst.AREA]: {
    label: '地区マスタ',
    sourceKey: 'areas',
    codeCategory: 'Area',
    columns: [
      { header: '地区コード', accessor: 'areaCode', width: 'w-32' },
      { header: '地区名', accessor: 'areaName' },
      { header: '更新日時', accessor: 'updatedAt', type: 'date' },
      { header: '削除済', accessor: 'isDeleted', type: 'checkbox' },
    ],
  },
} as const;